import React from 'react';
import { Badge } from '@odin-labs/components';
import { AnnouncementInput, announcementTypeColor } from './constants';

export function AnnouncementTypeBadge(
  props: AnnouncementInput,
): React.ReactElement {
  const { announcement } = props;
  return (
    <Badge
      text={
        announcement?.announcementType === 'Sms'
          ? 'SMS'
          : announcement?.announcementType
      }
      color={announcementTypeColor[announcement?.announcementType]}
      size="lg"
    />
  );
}
